module.exports = __webpack_public_path__ + "img/signed.56eed577.png";